import { useCallback } from 'react';
import useUserDetails from '../hooks/useUserDetails';
import { getSchoolReport } from '../../services/workflowService';
import ViewReportLink from '../reusable/ViewReportLink';

interface ViewSchoolReportLinkProps {
  schoolId: string;
}

const ViewSchoolReportLink = ({ schoolId }: ViewSchoolReportLinkProps) => {
  const {
    userDetails: { data: userDetails },
  } = useUserDetails();

  const fetchUrl = useCallback(async () => {
    if (!userDetails) return null;
    const report = await getSchoolReport(userDetails.eoaId, schoolId, userDetails.access_token);
    return report.pdf_download_url;
  }, [userDetails, schoolId]);

  return <ViewReportLink fetchUrl={fetchUrl} />;
};

export default ViewSchoolReportLink;
